import { type IButtonActionLogicComponentProps } from './common/IButtonActionLogicComponentProps.ts';
import { ButtonActionExecAsyncServiceLogicComponent } from './exec-async-service/ButtonActionExecAsyncServiceLogicComponent.tsx';
import { ButtonActionType, type IButtonAction } from './IButtonAction.ts';
import { ButtonActionListAddLogicComponent } from './list-add/ButtonActionListAddLogicComponent.tsx';
import { ButtonActionListRemoveLogicComponent } from './list-remove/ButtonActionListRemoveLogicComponent.tsx';
import { ButtonActionSubsectionOpenLogicComponent } from './subsection-open/ButtonActionSubsectionOpenLogicComponent.tsx';

/**
 * Componente react che renderizza l'action corretta in base al tipo di azione.
 * Le action sono tutte "logiche" e non renderizzano nulla, ma si limitano a gestire
 * l'evento onClick del pulsante padre.
 */
export function ButtonActionLogicSwitch(
  props: IButtonActionLogicComponentProps<IButtonAction>,
) {
  const { action, ...otherProps } = props;
  switch (action.type) {
    case ButtonActionType.ListAdd:
      return (
        <ButtonActionListAddLogicComponent {...otherProps} action={action} />
      );
    case ButtonActionType.ListRemove:
      return (
        <ButtonActionListRemoveLogicComponent {...otherProps} action={action} />
      );
    case ButtonActionType.SubsectionOpen:
      return (
        <ButtonActionSubsectionOpenLogicComponent
          {...otherProps}
          action={action}
        />
      );

    case ButtonActionType.ExecAsyncService:
      return (
        <ButtonActionExecAsyncServiceLogicComponent
          {...otherProps}
          action={action}
        />
      );
    default:
      return null;
  }
}
